import React from 'react';

const ScoreBar = ({ score, maxScore = 5000 }) => {
 const percentage = Math.min((score / maxScore) * 100, 100);

 return (
 <div className="flex items-center gap-1.5">
 <div className="w-14 h-2 bg-surface-3 overflow-hidden">
 <div
 className="h-full"
 style={{
 width: `${percentage}%`,
 background: 'var(--accent)'
 }}
 />
 </div>
 <span className="text-xs text-text-secondary">
 {score.toLocaleString()}
 </span>
 </div>
 );
};

export default ScoreBar;
